import { render, staticRenderFns } from "./EditarTipoEntrada.vue?vue&type=template&id=2a8e7942"
import script from "./EditarTipoEntrada.vue?vue&type=script&lang=js"
export * from "./EditarTipoEntrada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports